import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import PluginList from './pages/PluginList';
import Dashboard from './pages/Dashboard';
import Log from './pages/Log';
import Scan from './pages/Scan';
import Wizards from './pages/Wizards';
import Setting from './pages/Setting';
import Documentation from './pages/Documentation';
import { ran_setup_wizard } from '../src/Helpers';

const App = () => {

    const ran_setup = ran_setup_wizard();

    return (
		<>
			<Routes>
                <Route 
                    path="/" 
                    element={ran_setup ? <Dashboard /> : <Wizards />}
                />

                <Route 
                    path="/log" 
                    element={<Log />} 
                />

                <Route 
                    path="/scanner" 
                    element={<Scan />} 
                />

                
                <Route 
                    path="/author" 
                    element={<PluginList />} 
                />

                <Route 
                    path="/settings" 
                    element={<Setting />} />
                
                <Route 
                path="/doc" 
                element={<Documentation />} 
                />

            </Routes>
		</>
	);
 
}


export default App; 